export default "__VITE_ASSET__bd557c5f__"